import { render } from "./AdminNoticiasComponent.vue?vue&type=template&id=3951f89a&scoped=true"
import script from "./AdminNoticiasComponent.vue?vue&type=script&lang=js"
export * from "./AdminNoticiasComponent.vue?vue&type=script&lang=js"

import "./AdminNoticiasComponent.vue?vue&type=style&index=0&id=3951f89a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3951f89a"]])

export default __exports__